<template>
    <div>
        <el-card class="card-box">
            <div>
                <img class="card-img" :src="imgUrl">
            </div>

            <div class="btn-box">
                <el-button round @click="clickCardBtn">選擇</el-button>
            </div>
        </el-card>
    </div>
</template>

<script setup>
    import {onMounted, ref, inject} from "vue";
    import myUtil from "@/util/util";

    const props = defineProps(['cardObj', 'cardIndex'])
    const emits = defineEmits(['clickCardBtn'])

    const { changeDepart } = inject('myCardViewFunc', { changeDepart: () => {} })

    const imgUrl = ref(null)

    function clickCardBtn(){
        changeDepart(props.cardIndex)
    }

    onMounted(() => {
        imgUrl.value = myUtil.generateCardImgUrl(props.cardObj.cardinfo)
    })
</script>

<style scoped>
    .card-box {
        padding: 15px;
        text-align: center;
    }

    .card-img {
        max-width: 100%;
        min-height: 50px;
        object-fit: scale-down;
        border: 1px #EBEEF5 solid;
        box-sizing: border-box;
    }

    .btn-box {
        margin-top: 10px;
    }
</style>